<template>
	<div class="motion">
		<header class="disable">
            <img src="../assets/image/left.png" alt="" srcset="" class="returnBack">
            <span>{{useTitle}}</span>
        </header>
		<main class="productDetail">
			<div class="title">{{useTitle}}</div>
			<div class="page-main">
				<div class="page" v-for="(item,index) in  paragraphs" :key="index">
					<div v-if="item.paragraphType == 'IMAGE'" >
						<img :src="itemImage" alt="" class="page-img" v-for="(itemImage,index) in item.paragraphContent.split(';')" :key="index">
					</div>
					
					<p class="page-article" v-if="item.paragraphType == 'WORD'" v-html="item.paragraphContent">
					</p>
					<div  v-if="item.paragraphType == 'VIDEO'" class="vedio">
						<!-- <video width="100%"  height="180" controls="controls" :src="item.paragraphContent.split(';')[1]"  :poster="item.paragraphContent.split(';')[0]"  :key="index">
						</video>  -->
						<video-player  class="video-player vjs-custom-skin"
						ref="videoPlayer" 
						:playsinline="true" 
						:options="{poster:item.paragraphContent.split(';')[0],sources:[{type:'',src:item.paragraphContent.split(';')[1]}],height:'200px',fluid: true}"
						></video-player>
					</div>
				</div>
			</div>
			<div>
			</div>
		</main>
		
	</div>
</template>
<script>
import { getDeviceUse } from "../api/index.js"
export default {
	data(){
		return{
			msg:'',
			deviceId:'',
			paragraphs :[],//段落
			deviceVideoList:[], //推荐视频
			articleTitle:'',
			src:'',
			useTitle:''
		}
	},
	created(){
		this.deviceId = this.$route.query.deviceId;
		this.getMain();
	},
	methods:{
		getMain(){
			getDeviceUse(this.deviceId).then(res=>{
				res = res.data;
				if(res.resultStatus){
					this.useTitle = res.resultData.useTitle;
					this.paragraphs = res.resultData.paragraphs
				}else{
					
				}
				this.msg = res;
			}).catch()
		}
	}
}
</script>
<style lang='less'>
	.disable{
        display: none;
    }
	header {
		width: 100vw;
		height: 44px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		background-color: #fff;
		line-height: 44px;
		text-align: center;
		font-size: 16px;
		color: #000;
	}
	main{
		width: 100vw;
		/* padding-top: 44px; */
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		overflow: hidden;
		word-break: break-all;
	}
	.returnBack{
        position: relative;
        width:9px;
        height: 16px;
        float: left;
        top:14px;
        left:20px
    }
	.title{
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600;
		margin-top: 20px;
		margin-bottom: 16px;
		color:rgba(51,51,51,1);
	}
	.page-article{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1);
		line-height:24px;
	}
	.page-img{
		width: 100%;
		height:200px;
		margin-top: 12px;
		margin-bottom: 12px;
	}
	.video-js .vjs-icon-placeholder {
		width: 100%;
		height: 100%;
		display: block;
	}
	.vedio{
		border-radius: 5px;
		overflow: hidden;
		margin: 10px 0;
		height: 200px;
	}
	.vjs-poster{
		background-size: 100% 100%;
	}
	.productDetail{
		.vjs-poster{
			background-size: 100% 100%;
			height: 220px;
			bottom: 0;	
		}
		.video-js .vjs-tech {
			position: absolute;
			/* top: 0; */
			left: 0;
			width: 100%;
			height: 200px;
			bottom: 0;
		}
		.vjs-custom-skin > .video-js{
			height: 200px;
		}
		.vjs-control-bar{
			top:160px;
		}
		.vjs-big-play-button{
			.vjs-icon-placeholder{
				font-size: 20px !important;
				position: relative;
				top: -22px;
				color: rgba(255,255,255,0.8);
			}
		}
		.vjs-custom-skin > .video-js .vjs-big-play-button{
			top: 117px;
			left: 53vw;
			width: 30px;
			height: 30px !important;
			border-radius: 50%;
			border:3px solid rgba(255,255,255,0.8)
		}
	}
</style>
